/** @format */
import React, { useState } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";

const Header = () => {
  const [active, setactive] = useState("About");
  return (
    <header className='fixed h-[60px] w-screen backdrop-blur-sm bg-white/20 z-50 grid content-cente lg:text-xl'>
      <nav className='max-w-5xl flex gap-5 place-items-center w-full p-5'>
        <StyledLink active={active} href='About' setactive={setactive} />
        <StyledLink active={active} href='Examples' setactive={setactive} />
        <StyledLink active={active} href='Contacts' setactive={setactive} />
      </nav>
    </header>
  );
};

export default Header;

const StyledLink = ({ href, active, setactive }) => {
  console.log("StyledLink", active, href.toLowerCase());

  return (
    <AnchorLink
      href={`#${href.toLowerCase()}`}
      onClick={() => setactive(href)}
      className={
        active === href
          ? "active-link hover:scale-105 hover:font-bolder"
          : "hover:scale-105  hover:font-bolder"
      }>
      {href}
    </AnchorLink>
  );
};
